import { render, staticRenderFns } from "./PurchaseReturnExecution.vue?vue&type=template&id=4080c481"
import script from "./PurchaseReturnExecution.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnExecution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports